import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const RotatingText = ({ items, interval = 2400, className = '', testId }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!items || items.length === 0) return undefined;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % items.length);
    }, interval);
    return () => clearInterval(id);
  }, [items, interval]);

  if (!items || items.length === 0) return null;

  return (
    <span className={`inline-flex relative align-baseline ${className}`} data-testid={testId}>
      <AnimatePresence mode="wait">
        <motion.span
          key={index}
          initial={{ y: 18, opacity: 0, filter: 'blur(6px)' }}
          animate={{ y: 0, opacity: 1, filter: 'blur(0px)' }}
          exit={{ y: -18, opacity: 0, filter: 'blur(6px)' }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="whitespace-nowrap"
        >
          {items[index]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
};

export default RotatingText;
